<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'LICENSE_CATEGORIES', url: '/admin/license-categories' },
    { label: 'UPDATE_LICENSE_CATEGORY' }
  ]"
></breadcrumbs>

<page-header title="UPDATE_LICENSE_CATEGORY"></page-header>
<content-loading
  *ngIf="!(licenseTypes?.length && getField(['id']))"
></content-loading>

<ng-container *ngIf="licenseTypes?.length && getField(['id'])">
  <card>
    <form autocomplete="off" (submit)="onSubmit($event)">
      <div class="field is-narrow">
        <label class="label" translationEditableDirective="NAME">
          {{ 'NAME' | translate }}
        </label>
        <div class="control">
          <input
            class="input is-small"
            name="name"
            type="text"
            (input)="handleFieldChange($event)"
            [value]="getField(['name'])"
            [ngClass]="{ 'is-danger': hasError('name') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('name')">
          {{ getError('name') }}
        </p>
      </div>
      <div class="field is-narrow">
        <label class="label" translationEditableDirective="LICENSE_TYPES">{{
          'LICENSE_TYPES' | translate
        }}</label>
        <div class="control">
          <ng-select
            name="licenseTypeId"
            [items]="licenseTypes"
            [multiple]="false"
            [closeOnSelect]="true"
            [ngClass]="{ 'is-danger': hasError('licenseType') }"
            bindLabel="name"
            bindValue="id"
            (change)="handleFieldChange($event?.id, 'licenseTypeId')"
            [ngModelOptions]="{ standalone: true }"
            [ngModel]="getField(['licenseTypeId'])"
            class="is-small"
          >
          </ng-select>
        </div>
        <p class="help is-danger" *ngIf="hasError('licenseTypeId')">
          {{ getError('licenseTypeId') }}
        </p>
      </div>
    </form>
  </card>
  <div class="field is-grouped px-3">
    <div class="control">
      <button
        [disabled]="isLoading"
        type="submit"
        class="button is-success"
        (click)="onSubmit($event)"
        translationEditableDirective="SUBMIT"
      >
        {{ 'SUBMIT' | translate }}
      </button>
    </div>
    <div class="control">
      <button
        [disabled]="isLoading"
        type="submit"
        class="button is-info"
        (click)="onSubmit($event, false)"
        translationEditableDirective="SUBMIT"
      >
        {{ 'SAVE' | translate }}
      </button>
    </div>
    <div class="control">
      <a
        [routerLink]="['/admin/license-categories']"
        class="button is-link is-light"
        translationEditableDirective="CANCEL"
      >
        {{ 'CANCEL' | translate }}
      </a>
    </div>
  </div>

  <business-subcategories></business-subcategories>
</ng-container>
